module.exports = __webpack_public_path__ + "img/MasterCard.f1e509e6.svg";